// 中文
export default {
  download: "下载",
  OurCases: "我们的生产线",
  QualificationsandHonors: "Qualifications Honors",
  Currentlocation: "当前位置",
  NewsandInformation: "新闻资讯",
  source: "来源",
  Releasetime: "发布时间",
  Clickcount: "点击数",
  Back: "返回",
  ProfessionalManufacturing: "专业制造",
  ProductCenter:'产品中心',
  ProductOverview:'产品概述',
  RelatedProducts:'相关产品',
  Submissionsuccessful:'提交成功',
  rules: {
    submit: "提交",
    nameRequired: "请输入姓名",
    emailRequired: "请输入邮箱",
    phoneRequired: "请输入电话",
    addressRequired: "请输入地区",
  },
  navs: {
    home: "首页",
    product: "产品",
    ts: "生产研发",
    news: "新闻",
    AboutUs: "关于我们",
    ContactUs: "联系我们",
    Technology: "技术",
    Services: "研发",
    case: "生产",
  },
  home: {
    Seemore: "查看更多",
    Viewdetails: "查看详情",
  },
};
